import React, { useState, useEffect } from "react";
import { Button, Container, Row, Col, Card, Form } from "react-bootstrap";
import visaApi from "../apis/Visa.js";

function SendEmail({ t, toast, setShowSendEmailToDeveloper }) {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [emailTo, setEmailTo] = useState("");
  const [mobile, setMobile] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await visaApi.sendEmailToDeveloper({
      Subject: subject,
      Message: message,
      EmailTo: emailTo,
      Mobile: mobile,
    });
    if (response.success) {
      toast.success(t("visa.emailModal.emailSentSuccessfully"));
      setShowSendEmailToDeveloper(false);
    } else {
      toast.error(t("visa.emailModal.emailSentFailed"));
    }
  };

  return (
    <Container className="mt-5">
      <Card>
        <Card.Header as="h4">Send Email</Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Subject</Form.Label>
              <Form.Control type="text" value={subject} onChange={(e) => setSubject(e.target.value)} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>My Email</Form.Label>
              <Form.Control type="email" value={emailTo} onChange={(e) => setEmailTo(e.target.value)} required />
              <div className="checkbox-notes-container">{t("visa.emailModal.emailToNote")}</div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mobile</Form.Label>
              <Form.Control type="tel" value={mobile} onChange={(e) => setMobile(e.target.value)} />
              <div className="checkbox-notes-container">{t("visa.emailModal.mobileNote")}</div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              Send Email
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default SendEmail;
